import { Spinner, Text } from "@chakra-ui/react";
import { cn } from "utils/helpers";

type Props = {
	className?: string;
	size?: "sm" | "md" | "lg" | "xl";
	label?: string;
};

export const LoadingSpinner = ({
	className,
	size = "lg",
	label = "Loading...",
}: Props) => {
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center gap-y-4 py-16",
				className
			)}
		>
			<Spinner
				size={size}
				color="primary"
			/>
			{label ? <Text fontSize="md">{label}</Text> : null}
		</div>
	);
};
